import { render, staticRenderFns } from "./PasoConfiguracionInicial.vue?vue&type=template&id=5d0dec64&scoped=true&"
import script from "./PasoConfiguracionInicial.vue?vue&type=script&lang=js&"
export * from "./PasoConfiguracionInicial.vue?vue&type=script&lang=js&"
import style0 from "./PasoConfiguracionInicial.vue?vue&type=style&index=0&id=5d0dec64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0dec64",
  null
  
)

export default component.exports